import styled from 'styled-components'

export const AlarmsTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .text {
        display: flex;
        flex-direction: column;
        gap: 16px;
        .text-title {
            font-weight: 600;
            font-size: 14px;
        }

        .text-body {
            font-weight: 400;
            font-size: 14px;
        }
    }
`

export const SaveButton = styled.button`
    border: 1px solid;
    border-color: ${({ theme }) => theme['blue-500']};
    text-transform: capitalize;
    color: ${({ theme }) => theme['gray-0']};
    background: ${({ theme }) => theme['blue-500']};
    padding: 4px 16px;
`
